<section class="section banner">
    <div [@bannerTrigger] class="container">
        <div class="section-box-banner">
            <div class="content">
                <div>
                    <!-- <h1>Hola, mi nombre es</h1> -->
                    <h1>{{"Banner.Pretitle" | translate}}</h1>
                </div>
                <div class='banner-title'>
                    <div *ngFor="let persona of personas">
                    <h2>{{persona.nombre}} {{persona.apellido}}</h2> 
                    <h3>{{persona.descripcion}}</h3>
                    <p>
                    <button class="boton_editar2" (click)="editItem(persona.id)">
                        <img class="boton_editar2" src="/assets/images/boton_editar_3.png"/>
                    
                    </button>
                </p>
                    </div>
                </div>
                <div class='banner-description'>
                </div>
                <p>{{bannerDesc?.description}}</p>
                <p><button class="boton_editar" (click)="goToEditBanner()">
                    <img class="boton_editar" src="/assets/images/boton_editar_3.png"/>
                </button></p>
            </div>
            <div class="div-btn-banner">
                <a href="mailto:testmail@mail.com" target="_black" class="main-btn">
                    Enviar Correo
                </a>
            </div>
        </div>
    </div>
</section>